"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _Image = _interopRequireDefault(require("../../../atoms/Image"));

var OnlineOrderingNavigationHeader = function OnlineOrderingNavigationHeader(_ref) {
  var logo = _ref.logo,
      businessName = _ref.businessName,
      atBaseHeight = _ref.atBaseHeight;

  var Logo = function Logo(_ref2) {
    var className = _ref2.className;
    return /*#__PURE__*/_react["default"].createElement(_Image["default"], {
      src: logo,
      className: className
    });
  };

  var BusinessName = function BusinessName(_ref3) {
    var className = _ref3.className;
    return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Header, {
      as: "h3",
      className: className
    }, businessName);
  };

  return logo.length > 0 ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(Logo, {
    className: "logo".concat(atBaseHeight ? ' hide' : ' show')
  }), /*#__PURE__*/_react["default"].createElement(BusinessName, {
    className: "business-name".concat(atBaseHeight ? ' show' : ' hide')
  })) : /*#__PURE__*/_react["default"].createElement(BusinessName, null);
};

var _default = OnlineOrderingNavigationHeader;
exports["default"] = _default;